"use strict";
/*---------------------------------------------------------------------------------------------
 * Copyright (c) Bentley Systems, Incorporated. All rights reserved.
 * See LICENSE.md in the project root for license terms and full copyright notice.
 *--------------------------------------------------------------------------------------------*/
Object.defineProperty(exports, "__esModule", { value: true });
exports.supportsHas = void 0;
const dom_js_1 = require("./dom.js");
/**
 * Returns true if the :has selector is supported in the browser
 */
const supportsHas = () => { var _a, _b, _c; return (_c = (_b = (_a = (0, dom_js_1.getWindow)()) === null || _a === void 0 ? void 0 : _a.CSS) === null || _b === void 0 ? void 0 : _b.supports) === null || _c === void 0 ? void 0 : _c.call(_b, 'selector(:has(+ *))'); };
exports.supportsHas = supportsHas;
